import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Progressieve overload, de sleutel tot groei!</title>
                <link rel="canonical" href={route("blogs.thirty-four")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog gaan we dieper in op progressieve overload. Dit trainingsprincipe is belangrijk voor iedereen die wil afvallen of gespierder wil worden! Wil je dus meer weten over deze vorm, lees dan deze blog."
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog gaan we dieper in op progressieve overload. Dit trainingsprincipe is belangrijk voor iedereen die wil afvallen of gespierder wil worden! Wil je dus meer weten over deze vorm, lees dan deze blog."
                />
                <meta property="og:url" content={route("blogs.thirty-four")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Progressieve overload, de sleutel tot groei! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/progressieve-overload.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/progressieve-overload.webp"
                                    type="image/webp"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/progressieve-overload.jpg"
                                    type="image/jpeg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/progressieve-overload.jpg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Progressieve overload, de sleutel tot groei!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt met een
                        nieuwe blog. In deze blog gaan we dieper in op
                        progressieve overload. Dit trainingsprincipe is
                        belangrijk voor iedereen die wil afvallen of gespierder
                        wil worden! Wil je dus meer weten over deze vorm, lees
                        dan deze blog.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Progressieve overload, wat is het?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het woord zegt het al, het is een progressieve vorm van
                        overladen. Wanneer we dit vertalen naar Jip en Janneke
                        taal betekent dit dat je een oefening elke keer zwaarder
                        belast door meer herhalingen, minder rust, ander tempo
                        of meer gewicht. Het lichaam is van nature lui en daarom
                        moeten we dit principe toepassen om het lichaam elke
                        keer van een nieuwe prikkel te voorzien en om ervoor te
                        zorgen dat we geen{" "}
                        <a
                            href={route("blogs.ninth")}
                            className="text-we-are-yellow"
                        >
                            spiermassa gaan verliezen
                        </a>
                        .
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe pas je progressieve overload toe?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zoals hierboven genoemd kun je op verschillende manieren
                        progressieve overload toepassen. Een van de manieren is
                        het verzwaren van het gewicht wat je gebruikt. In de
                        praktijk zullen die stapjes zijn van 0,25 kg tot 0,5 kg.
                        Belangrijk is dat je elke training opnieuw het gewicht
                        weer iets verhoogt om de prikkel te blijven ervaren. Een
                        andere manier is het verhogen van je herhalingen.
                        Wanneer je kunt bankdrukken met 80 kilo en dit tien keer
                        verplaatst krijgt, kun je progressieve overload
                        toepassen door elke training weer één herhaling meer te
                        proberen. Wanneer je een aantal herhalingen hebt
                        bereikt, bijvoorbeeld 15 herhalingen dan verhoog je het
                        gewicht en herhaal je deze cyclus opnieuw. Nog een
                        andere manier is het veranderen van tempo. Dit hebben we
                        al eerder besproken in onze blog over{" "}
                        <a
                            href={route("blogs.thirty")}
                            className="text-we-are-yellow"
                        >
                            tempowisselingen
                        </a>
                        .
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Welke factoren zijn nog meer belangrijk om een
                        effectieve overload te realiseren?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Progressieve overload toepassen zit niet alleen maar in
                        de training. Overige factoren zoals{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            voeding
                        </a>
                        ,{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                        >
                            slaap
                        </a>{" "}
                        en{" "}
                        <a
                            href={route("blogs.twenty-seven")}
                            className="text-we-are-yellow"
                        >
                            stress
                        </a>{" "}
                        zijn belangrijk om tot topprestatie te komen. Wanneer je
                        een dag weinig tot niet gegeten hebt mis je energie om
                        het uiterste uit je training te halen en zul je weinig
                        tot geen progressieve overload kunnen toepassen. Om
                        misverstanden te voorkomen is het bijhouden van een
                        ‘dagboek’ aan te raden. Buiten het noteren van je
                        gewichten, noteer je ook bijzonderheden zoals een korte
                        nacht door stress of weinig tot niet gegeten door drukte
                        op het werk. Hierdoor ontstaan er geen misverstanden
                        waarom je geen progressieve overload ervaart.
                    </p>

                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie: waarom is progressieve overload belangrijk?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het lichaam is van nature lui en dient telkens een
                        nieuwe prikkel te ervaren. Progressieve overload is de
                        manier om het lichaam geprikkeld te houden. Dit kun je
                        toepassen op verschillende manieren die hierboven te
                        lezen zijn. Houdt wel een ‘dagboek’ bij om misverstanden
                        te voorkomen. Pak het serieus aan, boekt vooruitgang!
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ervaren hoe het is om door middel van progressieve
                        overload ultieme resultaten te behalen? Vul onderstaand
                        contactformulier in en we zetten de koffie alvast klaar.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
